<template>
  <div
    class="flex flex-col w-full md:w-[220px] min-h-[286px] mb-4 md:aspect-[10/13] gap-4 animate-pulse"
  >
    <div class="h-[60%] bg-gray-lighter rounded-lg"></div>
    <div class="h-4 w-3/4 mr-auto bg-gray-lighter rounded"></div>
    <div class="h-4 w-1/2 mr-auto bg-gray-lighter rounded"></div>
  </div>
</template>
